// Copyright (c) 2017 Deere & Company

import FilteredTerritories from '../../shared/state/filtered-territories';
import actions from '../../actions-list';
import {getDefaultState as getWipDefaultState} from '../state';

const updateFilteredTerritories = (state, action) =>
    FilteredTerritories.update(state, {
        $set: action.territories
    });

export default (state = getWipDefaultState().filteredTerritories, action) => {

    const actionTypes = {
        [actions.UPDATE_TABM_FILTERED_TERRITORIES]: updateFilteredTerritories
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tabm/wip/reducers/filtered-territories.js